import services from './services';
import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from 'utils';
import {
  GetERP_SendGoodsByPage,
  ERP_AuditSendGoods,
  GetSendGoodsAuditStatistics
} from '@api/sendGoodsApi';
import {
  GetOrderFinanceAuditByPage,
  ERP_AuditOrder,
  GetERP_OrderById
} from '@api/orderApi';
import NProgress from 'nprogress';
import {
  MAP_LIST
} from '$http';
import $http from '$http';
import repayment from './components/repayment/index.vue' //还款
import paymentHistoryListDialog from './components/paymentHistoryListDialog/index.vue';

export default {
  mixins: [services],
  components: {
    paymentHistoryListDialog,
    repayment
  },
  data: function () {
    return {
      loading: false,
      lists: [],
      pageIndex: 1,
      pageSize: 10,
      totalSize: '',
      pageSizes: [10, 20, 50],
      query: this.getQuery(),
      ProjectTypes: MAP_LIST.INTENT_PROJECT,
      AccountTypes: [{
        id: 82,
        name: '智趣坞首期借款'
      }, {
        id: 83,
        name: '智趣坞二期借款'
      }, {
        id: 84,
        name: '智趣坞设备款'
      }, {
        id: 85,
        name: '智趣坞图书款'
      }],
      totalNum: 0,
      totalPrice1: 0,
      totalPrice2: 0,
      totalPrice3: 0
    }
  },
  methods: {
    getQuery() {
      return cloneDeep({
        AgentName: "",
        AgentId: "",
        AgentContactName: "",
        ProjectType: "",
        AccountType: "",
        RePayStartTime: "",
        RePayEndTime: "",
        LendStartTime: "",
        LendEndTime: "",
      });
    },
    //搜素查询
    onQuerySubmit() {
      this.pageIndex = 1;
      this.getList();
      this.GetAgentLendMoneyStatistics()
    },

    //重置
    onQueryClean() {
      this.query = this.getQuery();
      this.getList();
      this.GetAgentLendMoneyStatistics()
    },
    // 还款
    handleEdit(index, row) {
      this.$refs.refsRepayment.show({
        LendId: row.Id,
        TotalLendMoney: row.TotalUnpaidMoney
      })
    },
    //还款记录
    handleView(index, row) {
      console.log(row)
      this.$refs.refpaymentHistoryListDialog.show({
        LendId: row.Id
      });

    },
    //导出
    download() {
      this.$confirm('确认导出吗？', '提示', {}).then(() => {
        this.getList();
        var params = {
          Sid: this.$store.state.sysSid,
          Session: this.$store.state.sysSession,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        };
        for (let item in this.query) {
          let value = this.query[item];
          if (value != '') {
            params[item] = value;
          }
        }
        util.exportToFileV2("api/AgentLend/GetAgentLendMoneyExport", params, this);
      });
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
  },
  watch: {
    '$route' (to, from) {
      this.showOrHideAuditBtn();
    }
  },
  created() {
    //console.log(this.$route.query)
    this.query.AgentId = this.$route.query.AgentId
    this.getList();
    this.GetAgentLendMoneyStatistics()
  }

}


// WEBPACK FOOTER //
// ./src/pages/Agent/AgentLend/vm.js